<template>
  <div class="modalMod" @click="modalModFn"
       :style="{'z-index':modalModState?zIndex:'-100','opacity':modalModState?(opacity?opacity:'0'):'0'}">

  </div>
</template>

<script>
  export default {
    name: 'xk-modal-Mod',
    props: ['zIndex', 'opacity'],
    data () {
      return {
        modalModState: false
      }
    },
    methods: {
      modalModFn: function () {
        this.modalModState = !this.modalModState
        this.$emit('click', this.modalModState)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .modalMod {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 50%;
    top: 50%;
    transition: 0.3s all;
    transform: translate(-50%, -50%);
    background-color: rgba(0, 0, 0, 0.5);
    z-index: -100;
  }
</style>



// WEBPACK FOOTER //
// modalMod.vue?dbf5c562